import React, { useState } from 'react';
import ChatBot from './ChatBot';

const ChatBotButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen((v) => !v)}
        className="fixed bottom-6 right-6 z-[100] flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 shadow-lg hover:scale-105 transition-transform focus:outline-none"
        style={{ boxShadow: '0 4px 24px rgba(99,102,241,0.2)' }}
        aria-label="Open ChatBot"
      >
        <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 20h.01M8 20h.01M16 20h.01M21 12c0 4.418-4.03 8-9 8s-9-3.582-9-8a9 9 0 1118 0z" />
        </svg>
      </button>
      {open && (
        <div className="fixed bottom-24 right-6 z-[100] max-w-xs w-full">
          <ChatBot onClose={() => setOpen(false)} />
        </div>
      )}
    </>
  );
};

export default ChatBotButton;
